import './Header.scss';
import { CustomTooltip } from '@/components/custom-tooltip';
import { labels } from '@/locales/en.label';
import IconButton from '@mui/material/IconButton';
import { useUser } from 'features/users/context/userContext';
import useDeviceType from 'hooks/useDeviceType';
import { TbHotelService, TbZoomMoney } from 'react-icons/tb';
import { useLocation } from 'react-router-dom';
import { PropertySearch } from '../PropertySearch/PropertySearch';
import { AboutModal } from './about-modal';
import logoMobile from './logo-mobile.png';
import logo from './logo.png';
import { SelloutCount } from './sellout';

export const tabs = [
	'metrics',
	'forecast',
	'inventory',
	'pickup',
	'rates',
	'competitors',
	'kpi',
];

function PropertyDetails() {
	const { isAuthenticated } = useUser();
	const { isMobile } = useDeviceType();
	const location = useLocation();

	return (
		<>
			<div className='header__left-wrapper'>
				<div className='header__company-info'>
					<img
						alt='logo'
						src={isMobile ? logoMobile : logo}
						className='header__company-logo'
					/>
				</div>
				<div className='header__divider' />
				<div className='header__property'>
					<PropertySearch />
				</div>
			</div>

			<div className='header__icons'>
				{isAuthenticated && (
					<>
						<CustomTooltip
							content={<p>{labels.header.tooltip.rate_change_logs}</p>}
						>
							<IconButton
								disableFocusRipple
								disableRipple
								title='Rate Change Logs'
								aria-label='rate-change-logs'
								onClick={(e) => {
									e.preventDefault();
									if (location.pathname === '/rate_changes') {
										// Refresh the page
										window.location.reload();
									} else {
										// Navigate to /rate_changes
										window.location.href = '/rate_changes';
									}
								}}
							>
								<TbZoomMoney className='header__icon' />
							</IconButton>
						</CustomTooltip>
						<CustomTooltip
							content={<p>{labels.header.tooltip.rate_offset_logs}</p>}
						>
							<IconButton
								disableFocusRipple
								disableRipple
								title='Rate Offset Logs'
								aria-label='rate-offset-logs'
								onClick={(e) => {
									e.preventDefault();
									if (location.pathname === '/rate_offsets') {
										// Refresh the page
										window.location.reload();
									} else {
										// Navigate to /rate_offsets
										window.location.href = '/rate_offsets';
									}
								}}
							>
								<TbHotelService className='header__icon' />
							</IconButton>
						</CustomTooltip>
						<AboutModal />
						{/* Hidden from display until fully implemented per B20V-2035:
						<IconButton
							disableFocusRipple
							disableRipple
							aria-label='notification'
						>
							<MdNotifications
								size={20}
								className={'header__icon header__icon-disable'}
							/>
						</IconButton> */}
						<SelloutCount />
					</>
				)}
			</div>
		</>
	);
}

export default PropertyDetails;
